import { render } from "./createAutomationWithAI.vue?vue&type=template&id=3234f96c&scoped=true"
import script from "./createAutomationWithAI.vue?vue&type=script&lang=js"
export * from "./createAutomationWithAI.vue?vue&type=script&lang=js"

import "./createAutomationWithAI.vue?vue&type=style&index=0&id=3234f96c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3234f96c"]])

export default __exports__